{
  "stoppageTypes": {
    "standby": "Standby",
    "preventativeMaintenance": "Preventative Maintenance",
    "operatingDelay": "Operating Delay",
    "nonOperatingDelay": "Non Operating Delay",
    "maintenanceDown": "Maintenance Down",
    "breakdown": "Breakdown",
    "unclassified": "Unclassified (Auto-Detected)"
  },
  "stoppageSubTypes": {
    "operatingDelay": "Operating Delay"
  },
  "blastTypes": {
    "production": "Production",
    "ramp": "Ramp",
    "toe": "Toe",
    "trim": "Trim",
    "preSplit": "Pre-split"
  },
  "targetTypes": {
    "wasteTonnes": "Waste Tonnes",
    "oreTonnes": "Ore Tonnes",
    "construction": "Construction",
    "drilling": "Drilling",
    "blastedTonnes": "Blasted Tonnes",
    "oreDrillMetres": "Ore Drill Metres",
    "nonOreDrillMetres": "Non-Ore Drill Metres",
    "oreBlastedTonnes": "Ore Blasted Tonnes",
    "nonOreBlastedTonnes": "Non-Ore Blasted Tonnes",
    "rehandleTonnes": "Rehandle (Tonnes)",
    "crushingTonnes": "Crushing (Tonnes)",
    "gradeControlDrillMetres": "Grade Control Drill Metres",
    "brokenStock": "Broken Stock",
    "crushingGrade": "Crushing Grade",
    "tsfMovement": "TSF Movement",
    "oreBcm": "Ore BCM",
    "wasteBcm": "Waste BCM",
    "inpitMovement": "Inpit Movement",
    "toWasteDumpMovement": "To Waste Dump Movement",
    "drillMetres": "Drill Metres",
    "availability": "Availability",
    "uofa": "UofA",
    "productivity": "Productivity",
    "grade": "Grade",
    "assetUtilisation": "Asset Utilisation",
    "redrillRate": "Redrill Rate",
    "drillingHours": "Drilling Hours",
    "drillEngineHours": "Drill Engine Hours",
    "netPenetrationRate": "Net Penetration Rate",
    "drillingUtilisation": "Drilling Utilisation",
    "holesWithinTolerance": "Holes Within Tolerance",
    "blastedVolume": "Blasted Volume",
    "explosivesCharged": "Explosives Charged",
    "powderFactor": "Powder Factor",
    "explosivesCostPerTonne": "Explosives Cost per Tonne",
    "misfiresPerThousandHoles": "Misfires per 1,000 Holes",
    "vibrationCompliance": "Vibration Compliance",
    "fragmentationP80": "Fragmentation P80",
    "consumablesCostPerMetre": "Consumables Cost per Metre",
    "bitLife": "Bit Life",
    "effectiveUtilisation": "Effective Utilisation",
    "operatingEfficiency": "Operating Efficiency",
    "mtbf": "Mean Time Between Failures",
    "mttr": "Mean Time To Repair",
    "mtbm": "Mean Time Between Maintenance",
    "scheduledDowntime": "Scheduled Downtime",
    "effectiveProductivity": "Effective Productivity",
    "drillProductivity": "Drill Productivity",
    "drillEffectiveProductivity": "Drill Effective Productivity"
  },
  "targetBases": {
    "tonnesPerOperatingHour": "tonnes per operating hour",
    "bcmPerOperatingHour": "bcm per operating hour",
    "tonnesPerMachineDay": "tonnes per machine per day",
    "bcmPerMachineDay": "bcm per machine per day",
    "tonnesPerEffectiveHour": "tonnes per effective hour",
    "bcmPerEffectiveHour": "bcm per effective hour",
    "metresPerOperatingHour": "metres per operating hour",
    "metresPerMachineDay": "metres per machine per day",
    "metresPerEffectiveHour": "metres per effective hour"
  },
  "targetCategories": {
    "forecast": "Forecast",
    "plan": "Plan",
    "budget": "Budget",
    "actuals": "Actuals"
  },
  "jobTypes": {
    "trucking": "Trucking",
    "productionTrucking": "Production Trucking",
    "digging": "Digging",
    "productionDigging": "Production Digging",
    "blastHoleDrilling": "Blast Hole Drilling",
    "reverseCirculationDrilling": "Reverse Circulation Drilling",
    "horizontalDrilling": "Horizontal Drilling",
    "fireTruck": "Fire Truck",
    "breaker": "Breaker",
    "dozer": "Dozer",
    "grader": "Grader",
    "loader": "Loader",
    "waterTruck": "Water Truck",
    "topHammerDrilling": "Top Hammer Drilling",
    "dthDrilling": "DTH Drilling",
    "rotaryDrilling": "Rotary Drilling",
    "explosivesLoading": "Explosives Loading"
  },
  "locationTypes": {
    "other": "Other",
    "inPit": "In Pit",
    "dump": "Dump",
    "rom": "ROM",
    "stockpile": "Stockpile",
    "crusher": "Crusher",
    "pit": "Pit",
    "tailingsDam": "Tailings Dam"
  },
  "minePeriodTypes": {
    "month": "Month",
    "quarter": "Quarter",
    "year": "Year"
  },
  "operationalAreas": {
    "mining": "Mining",
    "crushing": "Crushing",
    "rehandle": "Rehandle"
  },
  "materialClasses": {
    "ore": "Ore",
    "waste": "Waste"
  },
  "holeTypes": {
    "production": "Production",
    "buffer": "Buffer",
    "trim": "Trim",
    "preSplit": "Pre-split",
    "toe": "Toe",
    "ramp": "Ramp",
    "pilot": "Pilot",
    "other": "Other"
  },
  "removalReasons": {
    "wornGauge": "Worn gauge",
    "brokenButton": "Broken button",
    "flatButtons": "Flat buttons (missed regrind)",
    "bodyWash": "Body wash",
    "crackedBody": "Cracked body",
    "threadFailure": "Thread failure",
    "lostInHole": "Lost in hole",
    "lockedCone": "Locked cone / bearing failure",
    "sealFailure": "Seal failure",
    "endOfLife": "End of life",
    "missing": "Missing"
  },
  "consumableTypes": {
    "buttonBit": "Button bit",
    "retracBit": "Retrac bit",
    "dthBit": "DTH bit",
    "triconeBit": "Tricone bit",
    "pdcBit": "PDC bit",
    "drillRod": "Drill rod / pipe",
    "shankAdapter": "Shank adapter",
    "coupling": "Coupling",
    "stabiliser": "Stabiliser",
    "deckBushing": "Deck bushing",
    "dthHammer": "DTH hammer",
    "rockDrill": "Rock drill",
    "rockDrillOil": "Rock-drill oil",
    "compressorOil": "Compressor oil",
    "threadGrease": "Thread grease"
  },
  "geoDrillingTypes": {
    "gradeControl": "Grade Control",
    "reverseCirculation": "Reverse Circulation",
    "rotaryAirBlast": "Rotary Air Blast"
  }
}
